// This file is automatically generated. Do not edit manually.

import { ReclamationState } from "src/api/generated/erp/db/types/enums/reclamationState";
import { ServerSideDataModelRequest } from "src/api/generated/common/dataGrids/serverSideDataModelRequest";
import { ServerSideDataModelResult } from "src/api/generated/common/dataGrids/serverSideDataModelResult";
import { ReclamationView } from "src/api/generated/erp/db/types/tables/reclamationView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ReclamationsDataGridApi {
	export async function getData(args: {
		states?: Array<ReclamationState>;
		reclamationRoundId?: number | null | undefined;
		siteId?: number | null | undefined;
		customerOrderId?: number | null | undefined;
		customerId?: number | null | undefined;
		responsiblePersonId?: number | null | undefined;
		reclamationLocationId?: number | null | undefined;
		searchQuery?: string;
		categoryIds?: Array<number>;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<ServerSideDataModelResult<ReclamationView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/dataGrid/getData",
			method: "POST",
			data: {
				states: args.states,
				reclamationRoundId: args.reclamationRoundId,
				siteId: args.siteId,
				customerOrderId: args.customerOrderId,
				customerId: args.customerId,
				responsiblePersonId: args.responsiblePersonId,
				reclamationLocationId: args.reclamationLocationId,
				searchQuery: args.searchQuery,
				categoryIds: args.categoryIds,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ServerSideDataModelResult<ReclamationView>;
	}
}
